import { useCallback } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { SchedulerWebHook, SchedulerWebHookId, SchedulerWebHooks } from '@playq/services-jobot-scheduler';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const webHooksQueryKeys: unknown[] = ['corp', 'webhooks', 'query'];

export const useWebHooksQuery = (
  options?: IUseQueryOptionsExtended<SchedulerWebHooks | undefined, GenericFailure | Error>
) => {
  const { mutate, ...res } = useEitherQuery(
    webHooksQueryKeys,
    () => services2.intergrationsWebHookService.retrieveAll(),
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  const mutateDeletedWebhook = useCallback(
    (id: SchedulerWebHookId) => {
      mutate((prevSchedulerWebHooks) => {
        if (prevSchedulerWebHooks) {
          const nextSchedulerWebHooks = new SchedulerWebHooks();
          nextSchedulerWebHooks.webHooks = prevSchedulerWebHooks.webHooks.filter(
            (h: SchedulerWebHook) => h.id.id !== id.id
          );
          return nextSchedulerWebHooks;
        }
      });
    },
    [mutate]
  );

  return {
    ...res,
    webHooks: res.data instanceof SchedulerWebHooks ? res.data.webHooks : [],
    mutate,
    mutateDeletedWebhook,
  };
};
